export default __webpack_public_path__ + "static/media/cyclops_3.707e09b6.svg";